<template>
    <button
      v-if="showInstallButton"
      @click="installPWA"
      class="btn-lien"
      aria-label="Installer l'application"
      type="button"
      title="Installer l'application"
    >
      <span class="text-sm sm:text-md text-black sm:text-primaire rounded-full bg-action sm:bg-white px-4 sm:px-2 py-2 sm:py-1 font-bold hover:bg-primaire sm:hover:bg-action hover:text-white" >Installer ⤵</span>
    </button>
</template>

<script>
export default {
  data() {
    return {
      deferredPrompt: null,
      showInstallButton: false,
    };
  },
  mounted() {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      console.log('beforeinstallprompt détecté', e);
      this.deferredPrompt = e;
      this.showInstallButton = true;
    });

    window.addEventListener('appinstalled', () => {
      console.log('PWA installée avec succès !');
      this.showInstallButton = false;
      this.deferredPrompt = null;
    });
  },
  methods: {
    installPWA() {
      if (!this.deferredPrompt) return;

      this.deferredPrompt.prompt();

      this.deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('Utilisateur a accepté l\'installation');
        } else {
          console.log('Utilisateur a refusé l\'installation');
        }
        this.deferredPrompt = null;
        this.showInstallButton = false;
      });
    },
  },
};
</script>
<style scoped>

</style>